const ACRONYMS = new Set(['sp']);

const snakeToCamel = (str) =>
  str.replace(/_([a-z0-9]+)/g, (_, word) =>
    ACRONYMS.has(word) ? word.toUpperCase() : word[0].toUpperCase() + word.slice(1),
  );

export const deepSnakeToCamel = (value) => {
  if (Array.isArray(value)) return value.map(deepSnakeToCamel);
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [snakeToCamel(k), deepSnakeToCamel(v)]),
    );
  }
  return value;
};

const camelToSnake = (str) => str.replace(/([A-Z])/g, (c) => `_${c.toLowerCase()}`);

export const deepCamelToSnake = (value) => {
  if (Array.isArray(value)) return value.map(deepCamelToSnake);
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [camelToSnake(k), deepCamelToSnake(v)]),
    );
  }
  return value;
};
